export interface FleetAgent {
  ip: string
	status: string
  name: string
  version: string
	capacity: Capacity
	servers: Server[]
  cpu: CPU
  memory: Memory
  network: Network
}

export interface Server {
  game: string;
  version: string;
  name: string;
  id: string;
  containerId: string;
  size: number;
  status: string;
  error: string;
  startedAt: string;
  ports: Ports;
}

export interface Ports {
  available: boolean;
  container: string;
  agent: number;
  http: number;
  simStart: number;
  simEnd: number;
}

export interface CPU {
  usage: number
  numCPUs: number
  threads: number
}

export interface Memory {
  used: number
  percent: number
  total: number
}

export interface Capacity {
  used: number
  total: number
}

export interface Network {
  totalBytesSent: number;
  totalBytesRecv: number;
  bytesSent: number;
  bytesRecv: number;

  totalPacketsSent: number;
  totalPacketsRecv: number;
  packetsSent: number;
  packetsRecv: number;
}

export function bytesToGB(bytes: number): number {
  return bytes / ( 1024 * 1024 * 1024);
}

export function bytesToMB(bytes: number): number {
  return bytes / ( 1024 * 1024);
}